/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import bgImage from "../../../src/Assets/Mask group.png";
// import boxLine from "../../Assets/NewList/box-line.png";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import soldout from "../../Assets/soldout.png";
import Button from "../Button/Button";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ClientInfo,
  GetProdBudSumData,
  handleLimit,
  MaxQuan,
  showMaxMessg,
  SupplierCapping,
  V3Data,
} from "../Utility/Utility";
import { setProduct } from "../../Store/Slices/productDataSlice";
import PurchaseLimitAlertTile from "../PurchaseLimitAlertTile/PurchaseLimitAlertTile";
import { encryptURLParam } from "../../Common/Axios/encrypt";

import ReedemType from "../Card/ReedemType";
const EarnPointsModal = ({
  show,
  handleClose,
  modalDataValue,
  modalClass,
  products,
}) => {
  const translation = getTranslationData();

  const navigate = useNavigate();
  const [moduleData, setModuleData] = useState([]);
  const isLogin = sessionStorage.getItem("login");
  const v3Data = V3Data();
  let priceDenominations = [];
  const priceData = modalDataValue?.clientProductDenomination;

  const dispatch = useDispatch();
  const conBudSumData = GetProdBudSumData();
  const [outOfStockLabel, setOutOfStockLabel] = useState([]);
  const [stockOutDenominations, setStockOutDenominations] = useState();
  const prodSumData = conBudSumData?.getCustomerProduct?.filter(
    (filterdata) => filterdata?.productIdentifier === String(modalDataValue?.id)
  );

  if (Array.isArray(priceData)) {
    priceDenominations = priceData.map(item => item?.denomination);
  }
  else {
    priceDenominations = [];
  }
  useEffect(() => {
    if (priceData) {
      priceDenominations = priceData.map((item) => item?.denomination);
      setStockOutDenominations(priceData.every((item) => item?.stockOut === true));
      setOutOfStockLabel(priceData.map(item => { return item?.stockOut }));
    }
  }, [stockOutDenominations, priceData,]);
  const [quantity, setQuantity] = useState(
    priceDenominations?.map((_, index) => (index === 0 ? 0 : 0))
  );

  const [finalAmount, setFinalAmount] = useState(0);

  const discount = modalDataValue?.customerDiscount;
  const supplierCapping = SupplierCapping();
  const maxQuan = MaxQuan();
  useEffect(() => {
    const newFinalAmount = priceDenominations?.reduce((acc, price, index) => {
      return acc + price * quantity[index];
    }, 0);
    setFinalAmount(newFinalAmount);
  }, [quantity, priceDenominations]);

  const handleIncrease = (index, item) => {
    setQuantity((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      newQuantities[index] += 1;

      if (newQuantities[index] === supplierCapping) {
        showMaxMessg(translation.max_capping_allowed, supplierCapping, 1, item);
      }

      return newQuantities;
    });
  };

  const handleDecrease = (index) => {
    setQuantity((prevQuantities) => {
      const newQuantities = [...prevQuantities];
      newQuantities[index] = Math.max(newQuantities[index] - 1, 0);
      return newQuantities;
    });
  };

  useEffect(() => {
    const newArrayData = priceDenominations
      ?.map((item, index) => ({
        denomination: item,
        you_pay: item - (item * discount) / 100,
        saving: (item * discount) / 100,
        quantity: quantity[index],
      }))
      .filter((obj) => obj.quantity > 0);

    setModuleData(newArrayData);
  }, [quantity, discount]);

  function calculateTotalQuantity(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }
  const handleClick = () => {
    const quantity = calculateTotalQuantity(moduleData);
    if (quantity === 0) {
      toast.error(translation?.pleaseAddTheProduct);
      return;
    }

    if (quantity > maxQuan) {
      showMaxMessg(translation.max_limit_allowed, maxQuan);
      return;
    }

    if (finalAmount > 0) {
      if (isLogin) {
        dispatch(setProduct(modalDataValue));
        // Encrypt the productId parameter before navigation
        const encryptedProductId = encryptURLParam(
          modalDataValue?.id.toString()
        );
        navigate(`/card?productId=${encryptedProductId}`, {
          state: { moduleData },
        });
      } else {
        // Encrypt the productId parameter for localStorage
        const encryptedProductId = encryptURLParam(
          modalDataValue?.id.toString()
        );
        const pathName = window.location.pathname;
        const search = window.location.search;
        localStorage.setItem(
          "ProductListPage",
          `/card?productId=${encryptedProductId}`
        );
        localStorage.setItem("ProductListPage_back", pathName + search);
        // Store moduleData in sessionStorage for later use
        sessionStorage.setItem("arrayData", JSON.stringify(moduleData));
        window.location.href =
          v3Data?.SignInUrl +
          "/GIFTSTACC/SXNQb3N0UmVnaXN0cmF0aW9uTG9naW49dHJ1ZQ==";
      }
    }
  };

  const minEarnPoints = products?.find(
    (entry) => entry.id === modalDataValue?.id
  );
  const minEarn = minEarnPoints?.minEarnPoints;
  const getMinPrice = (priceDenominations) => {
    const pricesArray = String(priceDenominations).split(",");
    const pricesNumbers = pricesArray.map(Number);
    return Math.min(...pricesNumbers);
  };

  const clientinfo = ClientInfo();
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isEarnView = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isearnview"
  )?.configValue;
  useEffect(() => {
    handleLimit(
      finalAmount,
      prodSumData,
      dispatch,
      translation,
      modalDataValue?.productBudget?.limits
    );
  }, [finalAmount]);
  return (
    <div className="modal_Quick">
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="exampleModalLabel"
        centered
        className={`earn-points-modal ${modalClass}`}
      >
        <ToastContainer />
        <Modal.Body>
          <div
            id="amazon_gift_card"
            className="body position-relative-QuickModal modal-content-scrollable1"
          >
            {/* Fixed Header */}
            <div className="d-flex justify-content-between align-items-center fixed-top bg-white card_h_padding">
              <div>
                <div className="popup-header mb-5-px">
                  <h5 className="heading mb-0">{modalDataValue.name}</h5>
                  <span
                    className="modal-cross"
                    role="button"
                    onClick={handleClose}
                  >
                    <i className="fa-solid fa-xmark xmark_FS"></i>
                  </span>
                </div>

                <span className="pro-discount1 pro-discount-modal">
                  {modalDataValue?.customerDiscount !== 0 &&
                    `${translation.discount_flat} ${modalDataValue?.customerDiscount}%`}
                </span>
                <ReedemType status={modalDataValue?.redeemableType || ""} />
                {stockOutDenominations ? (
                  <div className="mod-head redeem-padd mt-3">
                    <h5 className="heading1 mb-0">

                      {translation.AvailabilityOfDenominations}

                    </h5>
                  </div>
                ) : (
                  <div className="mod-head">
                    <h5 className="heading1 mb-0">
                      {/* {modalDataValue.name.length > 30
                      ? modalDataValue.name.substring(0, 30) + "..."
                      : modalDataValue.name} */}
                      {maxQuan !== 0 && translation?.chooseYourDenomination && (
                        <>
                          {translation.chooseYourDenomination} (up to {maxQuan})
                        </>
                      )}
                    </h5>
                  </div>
                )}
              </div>
            </div>
            {/* Scrollable Content */}
            <div className="modal-content-scrollable mb-1 pt-0">
              {stockOutDenominations && (
                <div className="redemption_soldOutBox text-center mt-2 mb-4">

                  <div className="stockout-image ">
                    <img src={soldout} alt="Sold Out" className="mb-1" />
                    <p className="stockout-text ">
                      {translation?.stock_out}
                    </p>
                    <p>{translation?.stockout_message_desc_all_denomination}

                    </p>
                  </div>
                </div>
              )}

              {priceDenominations?.map((item, index) => (

                <div
                  className={`d-flex justify-content-between align-item-center mb-3 position_relatives ${index === 0 ? "pt-2" : ""
                    }`}
                  key={index}
                >
                  {!stockOutDenominations && (
                    <>
                      <div className="d-flex modal_discount_price" style={outOfStockLabel?.[index] ? { filter: "grayscale(1)", opacity: '0.6' } : {}}>
                        <div
                          className="amount-box"
                        // className="background_image"
                        // style={{ backgroundImage: `url(${bgImage})` }}
                        >
                          <div className="price_in_box rs_price">
                            <span className="currency">₹</span>
                            <span className="amount">{item}</span>
                          </div>

                          {/* <img alt="not-found" src={boxLine} /> */}
                        </div>
                        <div className="font-blk mr-10 col-lg-3 col-3">
                          <span className="padd-lft">
                            {modalDataValue?.customerDiscount !== 0 &&
                              item !== item - (item * discount) / 100 ? (
                              <>
                                <strike
                                  className={`pro-mrp`}
                                  style={{ textDecoration: "line-through" }}
                                >
                                  ₹{item}
                                </strike>
                                &nbsp;&nbsp;
                              </>
                            ) : (
                              ""
                            )}
                            <span className="actual-mrp">
                              ₹
                              {(() => {
                                const value = item - (item * discount) / 100;
                                const isWhole = value % 1 === 0;
                                return value.toLocaleString(undefined, {
                                  minimumFractionDigits: isWhole ? 0 : 2,
                                  maximumFractionDigits: 2,
                                });
                              })()}
                            </span>
                          </span>

                          {isEarnView
                            ? isEarnView !== 2 &&
                            Math.round(
                              (minEarn / getMinPrice(priceDenominations)) *
                              (item - (item * discount) / 100)
                            ) !== 0 && (
                              <div className={`fa_star_border`}>
                                <span className={`fa_star_box `}>
                                  {translation?.earn}&nbsp;
                                </span>
                                <span className="fa_star_box">
                                  {" "}
                                  {Math.round(
                                    (minEarn / getMinPrice(priceDenominations)) *
                                    (item - (item * discount) / 100)
                                  )}{" "}
                                  {translation?.pts}
                                </span>
                              </div>
                            )
                            : Math.round(
                              (minEarn / getMinPrice(priceDenominations)) *
                              (item - (item * discount) / 100)
                            ) !== 0 && (
                              <div className={`fa_star_border`}>
                                <span className={`fa_star_box `}>
                                  {translation?.earn}&nbsp;
                                </span>
                                <span className="fa_star_box">
                                  {" "}
                                  {Math.round(
                                    (minEarn / getMinPrice(priceDenominations)) *
                                    (item - (item * discount) / 100)
                                  )}{" "}
                                  {translation?.pts}
                                </span>
                              </div>
                            )}
                        </div>
                      </div>

                      {outOfStockLabel?.[index] ? (
                        <div className="stockOutContent">
                          <div className="stockOut">
                            {translation?.out_of_stock}
                          </div>
                        </div>
                      ) : (
                        <div className="number modal-inc_dec_btn d-flex align-item-center col-2">
                          {quantity[index] > 0 && (
                            <>
                              <button
                                className="minus mp-b"
                                onClick={() => handleDecrease(index)}
                              >
                                −
                              </button>
                              <input
                                className="item-qnty mod-qnty"
                                type="text"
                                value={quantity[index]}
                                readOnly
                              />
                            </>
                          )}

                          <button
                            className={`plus mp-b ${quantity[index] === supplierCapping
                              ? "quantity-disabled"
                              : ""
                              }`}
                            onClick={() => handleIncrease(index, item)}
                            disabled={
                              quantity[index] === supplierCapping || v3Data?.disable
                            }
                          >
                            +
                          </button>
                        </div>
                      )}
                    </>
                  )}

                </div>
              ))}

            </div>
            <div className="mod-pad1">
              {v3Data?.disable && (
                <PurchaseLimitAlertTile
                  timePeriod={v3Data?.timePeriod}
                  amount={v3Data?.amount}
                  reset_text={v3Data?.reset_text}
                  name={modalDataValue?.name}
                />
              )}

              <div>
                <Button
                  className="col-12 continue-btn mt-2 btn-sz font-black"
                  onClick={stockOutDenominations ? null : handleClick}
                  text={translation.continue}
                  disabled={v3Data.disable || stockOutDenominations}
                />

                {/* 
                <Button
                  onClick={handleClose}
                  text={translation.cancel}
                  className="cancel-link"
                /> */}
                <div className="redeem-padd info-box text-center">
                  <span className="redeem-txt-clr">{`${translation?.redeem_text} `}</span>
                  {translation?.redeemPointsCheckout}
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EarnPointsModal;
